import { getBackendServer } from '@automation/core/utils';
import { getAutomationBackendServer } from './utils';

const backendUrl = getBackendServer();
const automationBackendUrl = getAutomationBackendServer();

export const getDepartmentsUrl = () => `${backendUrl}/GetCompanyCareerPageDepartmentList`;
export const getCitiesUrl = () => `${backendUrl}/GetCompanyCareerPageCityList`;
export const getJobsListUrl = () => `${backendUrl}/GetCompanyCareerPageJobList`;
export const getJobDescriptionUrl = (jobId) => `${backendUrl}/GetCompanyCareerPageJobPageInfo/${jobId}`;

export const getRecruitmentTeamInfoUrl = () => `${automationBackendUrl}/v1/careers/home-page-info`;
